// @ts-nocheck
import { Modal, Box, Typography, Button } from "@mui/material";
import { CustomIconButtonForSheet } from "../../../../../components/Custom/CustomIconButton";
import { Check, Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  closeViewDocumentModalAction,
  fetchContractorDocumentsById,
} from "../../../../../store/actions/config/contractorLink";
import { useEffect, useState } from "react";
import LoadingOverlay from "../../../../../components/Custom/LoadingOverlay";
import { DocAndContracts } from "./DocAndContracts";
import { getContractorAgreementState } from "../../../../../utils/methods/contract/contractMethods";
import ContractorDocumentsCard from "../../../../onboarding/ContractorDocumentsCard";

export const DocAndContractsViewer = () => {
  const { documents, contractorPDFUrls } = useSelector(
    (state) => state?.contractorLink,
  );
  const { modalStatus, contractorDetails, loading, contractorId } = documents;
  const [currentDocument, setCurrentDocument] = useState(null);
  const dispatch = useDispatch();

  // function to fetch the contractor document data

  function handleClose() {
    dispatch(closeViewDocumentModalAction());
  }

  useEffect(() => {
    if (!contractorId) return;
    dispatch(
      fetchContractorDocumentsById({
        payload: {
          params: {
            contractorId,
          },
        },
      }),
    );
  }, [contractorId, dispatch]);

  useEffect(() => {
    setCurrentDocument(
      getContractorAgreementState({
        contractorType: contractorDetails?.contractorType,
        contractorPDFUrls,
        existingDocument: contractorDetails?.contractorAgreementId,
      }),
    );
  }, [contractorDetails, contractorPDFUrls]);

  return (
    <Modal open={modalStatus} onClose={handleClose} sx={{ zIndex: 2000 }}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 24,
          borderRadius: "16px",
          padding: "20px",
          border: "2px solid #D175B6",
          backgroundColor: "#000",
          zIndex: 9,
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          minWidth: { xs: 0, sm: "400px" },
          minHeight: "400px",
          maxWidth: "90vw",
          maxHeight: "95vh",
          "@media (max-width: 600px)": {
            width: "97vw",
            maxWidth: "97vw",
            maxHeight: "96vh",
            padding: "12px",
            gap: "0.75rem",
          },
        }}
      >
        {loading ? <LoadingOverlay open /> : null}
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "1rem",
            flexShrink: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "1rem", sm: "1.5rem" },
              fontWeight: 500,
              flex: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            View Contracts
          </Typography>
          <CustomIconButtonForSheet
            sx={{ backgroundColor: "transparent !important", flexShrink: 0 }}
            onClick={handleClose}
          >
            <Close />
          </CustomIconButtonForSheet>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "1rem",
            flexDirection: "column",
            height: "100%",
            overflowY: "auto",
          }}
          className={"custom-scroll-design"}
        >
          {/* contractor details */}
          <DocAndContracts
            readOnly
            hideTitle
            isParentWraperEnabled={false}
            contractorId={contractorDetails?._id}
            currentDocument={currentDocument}
            removePadding
          />
          {contractorId && <ContractorDocumentsCard contractorId={contractorId} />}
        </Box>
      </Box>
    </Modal>
  );
};
